<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202411_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202411_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>いつから始めるべき？</span><br>エイジングケアを始める年齢</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <div class="feature-row mt-5 pt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202411_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">エイジングケア、みんないつから、何をしてる？</h3>
        <p class="mb-3">女性も男性も、年齢を重ねると肌の悩みを感じることが増えるもの。</p>
        <p class="mb-3">これは美容への意識が高い方だけではなく、多くの方に言えることかもしれません。</p>
        <p class="mb-3">そんな時、気になるのはエイジングケア※。</p>
        <p class="mb-3">では、何歳からエイジングケアを始める方が多いのでしょうか。</p>
        <p class="mb-3">そして、エイジングケアとしてどのようなことをしているのでしょうか。</p>
        <p>（※年齢に応じたケア）</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">気になる「エイジングケア」アイテムの選び方。</h3>
        <p class="mb-3">そうは言っても、「エイジングケアとは？」と、具体的にどんなことがいいのか迷う方も多いでしょう。</p>
        <p class="mb-3">まずはじめに、エイジングケアとは「年齢に応じたお手入れをすること」を指しています。</p>
        <p class="mb-3">そのため20代、30代、40代...と年齢を重ねたとしても、その時の自分に合うケアをすることがポイント。</p>
        <p class="mb-3">食や運動なども大切ですが、毎日のスキンケアの積み重ねもとても重要！</p>
        <p>しっかりとエイジングケア効果のあるアイテムを選ぶには、どんなところに注目したらいいのでしょうか？</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202411_03.jpg">
      </div>
    </div>
    
    <h2 class="my-5 pt-5">エイジングケア経験者の約半数が「20代」から始めてる！？<br>気になるみんなの「エンジングケア」の事情</h2>
    <p class="text-center mb-3">今回は20代、30代、40代の一般女性を対象として<br>エイジングケアの経験者と未経験者に<br>「エイジングケア」について調査を実施。</p>
    <p class="text-center mb-3">そこから見えたのは、エイジングケアに対する皆さんの意識の差と、<br>エイジングケアアイテムを選ぶときのキーポイント。</p>
    <p class="text-center mb-5 pb-5">若く見える人が、大切にしているポイントとは？</p>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">エイジングケアを始める年齢の理想と現実の差。</h3>
        <p class="mb-3">まずは気になる、エイジングケア経験者がケアを始めた年齢はいつ？</p>
        <p class="mb-3"><strong>「エイジングケアを始めた年齢を教えてください」</strong></p>
        <p class="mb-3"><strong>『20〜29歳（27.8％）』<br>『30〜39歳（47.1％）』<br>『40〜49歳（25.1％）』</strong></p>
        <p class="mb-3">始めるタイミングとしては30代が多いよう。自分自身でも年齢をシミ・シワなど目に見えてわかる”肌悩み”が気になる頃合いかもしれません。</p>
        <p class="mb-3"><strong>「エイジングケアを始めた年齢についてどう思いますか？」</strong></p>
        <p class="mb-3"><strong>『始めるのに妥当な年齢だった（60.3％）』</strong></p>
        <p>約6割の方がエイジングケアを始めたタイミングに満足している一方で、約3割が開始時期が遅かったと感じていることが明らかに。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202411_04.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202411_05.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">エイジングケアは20代から？始めるのは、早いことに越したことはない。</h3>
        <p class="mb-3">エイジングケア経験者の方へ<strong>「何歳くらいからエイジングケアを始めるべきだと思いますか？」</strong>と聞いたところ約半数が20代と回答。</p>
        <p class="mb-3">では、エイジングケア未経験者は<strong>「何歳くらいからエイジングケアを始めようと思っていますか？」</strong>と質問。</p>
        <p class="mb-3"><strong>『40〜49歳（45.3％）』<br>『30〜39歳（22.9％）』</strong></p>
        <p class="mb-3">エイジングケアを始める時期について、経験者は20代後半〜30代前半と答える一方、未経験者は40代前後から始めようと考えている方が多いよう。</p>
        <p class="mb-3">驚くことに、開始時期の認識に大きな差があることが明らかに。</p>
        <p>未経験者の約半数が考えている40代でエイジングケアをはじめると、遅い可能性があることがわかります。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">エイジングケア、大切なのは自分に合った情報収集。</h3>
        <p class="mb-3">エイジングケアの経験者こそ、20代など早い時期から始めることを推奨するという事実は見逃せないですね。</p>
        <p class="mb-3">では、未経験者がはじめられていない理由はなんでしょうか？</p>
        <p class="mb-3"><strong>「エイジングケアをまだ始めていない理由は何ですか？（複数選択可）」</strong></p>
        <p class="mb-3"><strong>『何から始めればよいかわからないから（40.9％）』<br>『費用がかかるから（38.9％）』<br>『面倒くさいから（25.6％）』</strong></p>
        <p class="mb-3">エイジングケアを始めるには、適切な方法や商品など何を選べばいいかわからない人も多いようです。</p>
        <p class="mb-3">また「費用がかかる」という意見についても、エイジングケアアイテムを使う効果と理由が理解できれば、手を伸ばしたくなる方もいるかもしれません。</p>
        <p>いずれにせよ、エイジングケアに関する情報をわかりやすく正確にキャッチすることが大切です。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202411_06.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202411_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">エイジングケア商品こそ、「成分」を見るべし</h3>
        <p class="mb-3">では、エイジングケア未経験者としては、経験者に何を聞きたい？</p>
        <p class="mb-3"><strong>「エイジングケア経験者に聞きたいことは何ですか？（複数選択可）」</strong></p>
        <p class="mb-3"><strong>『エイジングケアアイテムの選び方（34.7％）』<br>『エイジングケアの効果（32.3％）』<br>『エイジングケアにかけている費用（30.7％）』</strong></p>
        <p class="mb-3">やはりこれからエイジングケアを始めたい方が気になるのは、選び方と効果と費用のバランスのよう。</p>
        <p class="mb-3">実際にエイジングケア経験者は</p>
        <p class="mb-3"><strong>『効果（69.3％）』、『成分（59.9％）』『価格（39.4％）』</strong></p>
        <p class="mb-3">を重視しているとのこと。</p>
        <p>エイジングケアアイテムを選ぶ時は、効果だけではなくしっかりと成分と見合った価格も重視すべきですね。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">大切なのは"保湿"と"正しい選択"</h3>
        <p class="mb-3">エイジングケア経験者は具体的に<strong>『保湿（73.2％）』『紫外線対策（55.0％）』『適切なスキンケアアイテムの選択（36.5％）』</strong>を重視しているようです。</p>
        <p class="mb-3">いずれも、基本的なスキンケアですが<strong>「エイジングケアをしてどのような点に満足しましたか？（複数選択可）」</strong>と質問したところ</p>
        <p class="mb-3"><strong>『肌の乾燥が気にならなくなった（31.5％）』<br>『肌がなめらかになった（30.9％）』<br>『肌荒れが気にならなくなった（27.2％）』</strong></p>
        <p class="mb-3">エイジングケアにおいても、大切なのはやっぱり保湿！</p>
        <p>秋冬は気温が低くなり、空気も乾燥しがち。エイジングサインのひとつである「乾燥による小じわ」なども目立ちやすくなるため、丁寧な保湿が重要視されているのではないでしょうか。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202411_08.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202411_09.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3 text-center">エイジングケアを始める年齢に早すぎることはない。<br>保湿を重点的に、効果実感のある成分重視のアイテムがおすすめ</h3>
        <p class="mb-3">今回の調査結果で、エイジングケアに対する意識や行動に、エイジングケア経験者・未経験者で差があることが明らかに。</p>
        <p class="mb-3">特に注目すべきは、エイジングケアを始めるべき時期。未経験者の約半数が40代で意識をし始める一方で、経験者の約半数は、エイジングケアは20代から始めるべきと回答。このことからもエイジングケアは、自身のエイジングサインに気がついてから始めるには、遅いかもしれないことが示唆されます。</p>
        <p class="mb-3">エイジングケアをこれから始める方は「何から始めればよいかわからない」と迷うかもしれませが、何事も適切な基本と継続が大切。</p>
        <p>エイジングケアアイテムに関しても、美肌の基本の「保湿」や「紫外線ケア」が重要。加えて、よりエイジング効果を感じられる・期待できる「成分」が配合されているかを確認することが重要です。</p>
      </div>
    </div>

    <div class="layer_01  mt-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p>効果と成分重視する方におすすめしたい</p>
        <p class="mb-3 fs-2">薬用エイジングケアクリーム</p>
        <p class="mb-3">医薬部外品の認定を受けたこのアイテム。</p>
        <p class="mb-3">「有効成分ナイアシンアミド配合」の医薬部外品シワ改善クリームです。</p>
        <p class="mb-3">ハリ・弾力の低下など、加齢とともに変化していく肌をサポート。</p>
        <p class="mb-3">ラベンダーのやさしい香りで肌を包み、美しくしなやかな「弾力美肌」へ。</p>
        <p class="mb-3">あなたが未来の自分のお肌も<br>好きでいれるように。</p>
        <p>そのお手伝いができるスキンケアアイテムを<br>マナビス化粧品は提案します。</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5">エイジングケアにおすすめの<br>スキンケアアイテム</h2>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/agingcare_accset_202411.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">AGING CARE<br>薬用エイジングケアクリームセット</h3>
        <p class="mb-3">¥5,500<br>（2024/12/27までの限定価格）</p>
        <p class="mb-3">薬用エイジングケアクリームセット<br>（リフィル30ｇ、リユースジャーボトル）</p>
        <p class="mb-3">日々変化していく肌にうるおいとハリを与えます。</p>
        <p class="mb-3">美しくしなやかな「弾力美肌」へ。<br>ナイアシンアミド配合のエイジングケアクリーム。</p>
        <p class="mb-3">※エイジングケア：年齢に応じた、うるおいケア</p>
        <p>※ナイアシンアミド（整肌成分）</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>

    <h2 class="my-5">商品特長</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">濃密なハリとリッチな保湿あふれるエイジングケアクリーム。</p>
      <p class="mb-3">コラーゲンの生成やハリ・弾力の低下など、加齢と共に変化していく肌をサポートします。</p>
      <p class="mb-5">リラックス効果の高いラベンダーのやさしい香りで肌を包み、美しくしなやかな「弾力美肌」へ。</p>
      <h3 class="mb-3">特長成分</h3>
      <p class="mb-3">［有効成分］ナイアシンアミド</p>
      <p class="mb-3">［整肌成分］ツボクサエキス、セイヨウハッカエキス</p>
      <p>［保湿成分］ヒドロキシステアリルフィトウフィンゴシン、Ｎ－ステアロイルジヒドロスフィンゴシン、Ｎ－ステアロイルフィトスフィンゴシン、タイムエキス（１）</p>
    </div>
   
    <div class="layer_02">
      <img src="@/assets/img/column/202411_10.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left"><span>はじめての方におすすめ。</span><br>TRIAL SET</h2>
          <p class="mb-3">マナビス化粧品には、エイジングケアへフォーカスした商品以外にも、おすすめしたいアイテムがたくさん。</p>
          <p class="mb-3">一方でどのアイテムがいいか、迷ってしまう方も多いかもしれません。</p>
          <p class="mb-3">そこでまずは、はじめての方に</p>
          <p class="mb-3"><strong>一度でいいから使ってみてほしい</strong></p>
          <p class="mb-3">という思いから、お手軽に始めやすい1週間のミニサイズのセットをご用意しました。</p>
          <p class="mb-3">各ラインナップからおすすめのアイテムかわいらしいミニサイズに詰め合わせました。</p>
          <p>旅行のトラベルセットとしても、ちょっとしたプレゼントにも最適。</p>
        </div>
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>マナビストライアルセット</h3>
        <p class="mb-3">¥2,300</p>
        <p class="mb-3"><strong>美肌の基本は洗顔にあり</strong></p>
        <p class="mb-3">マナビス化粧品の定番アイテムをギュッと詰め込みました。</p>
        <p>「スキンウォッシュ」「スキンマスク」「エモリエントローション」のミニサイズと、ウォッシュ用 泡立てネットをセットにしました。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_trialset_202410.jpg">
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">その他のTRIAL SETシリーズ</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/trial_flora_202410.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">美肌菌トライアルセット</div>
          <p><strong>話題の「美肌菌」にフォーカスした注目のスキンケア</strong></p>
          <div class="feature-row_product_title">¥3,000</div>
          <p>フローラシリーズから「ファーストセラム」「スキンケアオイル」のミニサイズセット</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/trial_rising_202410.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">モイスチャライジングセット</div>
          <p><strong>うるおいのある美肌を目指すあなたに</strong></p>
          <div class="feature-row_product_title">¥2,300</div>
          <p>ロングセラーの「エモリエントローション」「モイスチャージェル」「リンクルジェル」のミニサイズセット</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/trial_whitening_202410.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">ホワイトニングセット</div>
          <p><strong>美白を目指す方に一度は試してほしい</strong></p>
          <div class="feature-row_product_title">¥2,150</div>
          <p>人気の「ホワイトニングエッセンス」「美白ローション」「レストアジェル」のミニサイズセット</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000010.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000010.000124389.html">【エイジングケアを始める年齢】経験者の約半数が「20代」だと回答する一方で、未経験者は「40代」からを検討中と大きな差異が明らかに</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p>調査概要：「エイジングケア」に関する調査<br>
        【調査期間】2024年11月18日（月）～2024年11月20日（水）<br>
        【調査方法】「PRIZMA」によるインターネット調査<br>
        【調査人数】1,019人<br>
        【調査対象】調査回答時に20～40代の①エイジングケア経験者／②エイジングケア未経験者と回答したモニター<br>
        【モニター提供元】PRIZMAリサーチ<br>
        ※この調査の内容は、あくまでアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: center;
      background-image: url('../../assets/img/column/202411_10.jpg');
      background-size: cover;
      min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
    }
    .layer_02 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>